import { z } from 'zod';
import { moneyStringSchema, uuidSchema } from './common';

export const submitManualPaymentSchema = z.object({
  orderId: uuidSchema,
  method: z.string().min(1).max(40),
  amount: moneyStringSchema,
  currency: z.string().length(3),
  reference: z.string().max(120).optional(),
  proofR2Key: z.string().min(1),
});

export const reviewManualPaymentSchema = z.object({
  decision: z.enum(['approved', 'rejected']),
  rejectionReason: z.string().max(500).optional(),
});

export const requestPayoutSchema = z.object({
  amount: moneyStringSchema,
  method: z.string().min(1).max(40),
  payload: z.record(z.unknown()).optional(),
});

export const processPayoutBatchSchema = z.object({
  payoutRequestIds: z.array(uuidSchema).min(1),
});
